import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css"
import ScrollToTop from "./components/Scrolltop";


import Header from "./components/top_head";
import Navbar from "./components/navbar";
import Down_nav from "./components/down_nav";


// Pages
import AbstractPage from "./pages/abstract";
import AnnouncementsPage from "./pages/announcements";
import E_linksPage from "./pages/e-links";
import BooksPage from "./pages/books";
import IntroPage from "./pages/intro";
import ArticlePage from "./pages/article2";
import NewsPage from "./pages/news";
import PosterPage from "./pages/posters";
import ReportPage from "./pages/reports";
import BibliographyPage from "./pages/bibliography";
import ForumPage from "./pages/forum";
import WebinarsPage from "./pages/webinar";
import EditorsPage from "./pages/editors";
import ExpertsPage from "./pages/experts";

function App() {
  return (
    <div className="body"
    style={{backgroundImage:'url(images/heatwaves2.png)',backgroundSize:"100% 100%",backgroundPosition:"center",backgroundRepeat:"no-repeat"}}>
        
      <Router basename="/biodiversity/sahyadri_enews/newsletter/Issue92/">
      <ScrollToTop />
        <Header />
        <Navbar />

        <Routes>
          <Route path="/" element={<AbstractPage />} />
          <Route path="/intro" element={<IntroPage />} />
          <Route path="/article/*" element={<ArticlePage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/posters" element={<PosterPage />} />
          <Route path="/report" element={<ReportPage />} />
          <Route path="/bibliography" element={<BibliographyPage />} />
          <Route path="/experts" element={<ExpertsPage />} />
          <Route path="/forum" element={<ForumPage />} />
          <Route path="/webinar" element={<WebinarsPage />} />
          <Route path="/editors" element={<EditorsPage />} />
          <Route path="/announcements" element={<AnnouncementsPage />} />
          <Route path="/books" element={<BooksPage />} />
          <Route path="/e-links" element={<E_linksPage />} />
        </Routes>

        <Down_nav />
      </Router>
    </div>
    
  );
}

export default App;
